import React from "react";
import PageHeader from "../components/marketing/PageHeader";
import ContactForm from "../components/marketing/ContactForm";
import { Reveal } from "../components/marketing/Reveal";
import { ACADEMY, WHATSAPP_LINK } from "../lib/constants";
import { Phone, Mail, Clock, MapPin, Instagram, Youtube, MessageCircle } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline="Get In Touch"
        title={<>Let's start <span className="italic gold-gradient-text">dancing</span>.</>}
        subtitle="Reach out to enquire about classes, timings and fees — we'd love to welcome you to Rythmbara."
      />

      <section className="bg-background py-24 md:py-32">
        <div className="rb-container grid lg:grid-cols-[1fr_1.1fr] gap-16">
          {/* Info */}
          <Reveal>
            <h2 className="font-serif font-light text-3xl md:text-4xl text-foreground mb-8">Contact details</h2>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <span className="grid h-11 w-11 place-items-center bg-secondary text-[var(--rb-gold)]"><Phone className="h-5 w-5" /></span>
                <div>
                  <p className="overline text-[10px] text-muted-foreground">Call</p>
                  <a href={`tel:${ACADEMY.phoneRaw}`} className="text-lg text-foreground hover:text-[var(--rb-gold)]" data-testid="contact-info-phone">{ACADEMY.phone}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid h-11 w-11 place-items-center bg-secondary text-[var(--rb-gold)]"><Mail className="h-5 w-5" /></span>
                <div>
                  <p className="overline text-[10px] text-muted-foreground">Email</p>
                  <a href={`mailto:${ACADEMY.email}`} className="text-lg text-foreground hover:text-[var(--rb-gold)]">{ACADEMY.email}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid h-11 w-11 place-items-center bg-secondary text-[var(--rb-gold)]"><MapPin className="h-5 w-5" /></span>
                <div>
                  <p className="overline text-[10px] text-muted-foreground">Studio Address</p>
                  <a href={ACADEMY.mapLink} target="_blank" rel="noopener noreferrer" className="text-base text-foreground hover:text-[var(--rb-gold)] leading-relaxed" data-testid="contact-info-address">{ACADEMY.address}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid h-11 w-11 place-items-center bg-secondary text-[var(--rb-gold)]"><Clock className="h-5 w-5" /></span>
                <div>
                  <p className="overline text-[10px] text-muted-foreground">Timings</p>
                  <p className="text-lg text-foreground">Morning {ACADEMY.hours.morning}</p>
                  <p className="text-lg text-foreground">Evening {ACADEMY.hours.evening}</p>
                </div>
              </li>
            </ul>

            <div className="mt-8 flex gap-3">
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="btn-gold inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold uppercase tracking-[0.15em]">
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
              <a href={ACADEMY.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="grid h-12 w-12 place-items-center border border-border text-foreground hover:bg-purple hover:text-[#F6F4EE] transition-colors"><Instagram className="h-5 w-5" /></a>
              <a href={ACADEMY.youtubeUrl} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="grid h-12 w-12 place-items-center border border-border text-foreground hover:bg-purple hover:text-[#F6F4EE] transition-colors"><Youtube className="h-5 w-5" /></a>
            </div>

            {/* Google Map */}
            <div className="mt-10 relative h-72 border border-border overflow-hidden" data-testid="map-embed">
              <iframe
                title="Rythmbara Dance Academy location"
                src={ACADEMY.mapEmbed}
                className="absolute inset-0 h-full w-full"
                style={{ border: 0, filter: "grayscale(0.15) contrast(1.05)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <a href={ACADEMY.mapLink} target="_blank" rel="noopener noreferrer" data-testid="map-directions" className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-foreground border-b-2 border-[var(--rb-gold)] pb-0.5 hover:gap-3 transition-all">
              <MapPin className="h-4 w-4 text-[var(--rb-gold)]" /> Get directions
            </a>
          </Reveal>

          {/* Form */}
          <Reveal delay={0.15} className="bg-card p-8 md:p-10 border border-border">
            <h2 className="font-serif font-light text-3xl md:text-4xl text-foreground mb-8">Send an enquiry</h2>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
